<template>
  <div class="mainPreloader" :style="cssVars" :class="additionalClass">
    <div class="mainPreloader__container">
      <svg :viewBox="viewBox" :width="size" :height="size" xmlns="http://www.w3.org/2000/svg">
        <circle
            :cx="rad"
            :cy="rad"
            :r="radCorrected"
            :stroke-width="stroke"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainPreloader',
  props: {
    size: {
      type: Number,
      default: 30,
    },
    stroke: {
      type: Number,
      default: 3,
    },
    strokeColor: {
      type: String,
      default: 'var(--cd-text)',
    },
    position: {
      type: String,
      default: 'relative',
    },
    background: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rad(){
      return this.size/2;
    },
    radCorrected(){
      return (this.size - this.stroke)/2;
    },
    viewBox(){
      return `0 0 ${this.size} ${this.size}`;
    },
    cssVars(){
      return {
        '--preloader-stroke-color': this.strokeColor,
        '--preloader-size': this.size + 'px',
        '--preloader-length': (Math.PI*this.radCorrected*3) + 'px',
      };
    },
    additionalClass(){
      return {
        'mainPreloader_background': this.background,
        'mainPreloader_absolute': this.position == 'absolute',
        'mainPreloader_fixed': this.position == 'fixed',
      };
    },
  }
}
</script>

<style scoped lang="scss">
$-preloader-spin-duration: 2s;
$-preloader-stroke-duration: 3s;

@keyframes spinPreloader {
  0%{
    transform: rotate(0deg) translateZ(0);
  }
  100%{
    transform: rotate(360deg) translateZ(0);
  }
}

@keyframes strokePreloader {
  0% {
    stroke-dasharray: 0, var(--preloader-length);
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: calc(var(--preloader-length)*0.7), calc(var(--preloader-length)*0.3);
    stroke-dashoffset: calc(var(--preloader-length)*(-0.2));
  }
  100% {
    stroke-dasharray: 0, var(--preloader-length);
    stroke-dashoffset: calc(var(--preloader-length)*(-0.7));
  }
}

.mainPreloader {
  width: var(--preloader-size);
  height: var(--preloader-size);
  font-size: 0;
  line-height: 0;
  // pointer-events: none !important;
  transform: translateZ(0);
  position: relative;
  margin: 0 auto;

  &__container {
    position: absolute;
    width: 0;
    height: 0;
    top: 50%;
    left: 50%;
    animation: spinPreloader $-preloader-spin-duration linear infinite;
  }

  svg {
    animation: strokePreloader $-preloader-stroke-duration linear infinite, ;
    stroke-dasharray: 1, var(--preloader-length);
    stroke-dashoffset: 0;
    stroke-linecap: round;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);

    circle{
      stroke: var(--preloader-stroke-color);
      fill: none;
    }
  }

  &_absolute {
    position: absolute;
    z-index: 40;
  }

  &_fixed {
    position: fixed;
    z-index: 40;
  }

  &_absolute,
  &_fixed {
    top: 50%;
    left: 50%;
    margin: calc(var(--preloader-size)*(-0.5));
  }

  &_background {
    border: 1px solid var(--pa-border);
    border-radius: 8px;
    background-color: var(--pa-light);
    box-sizing: content-box;
    padding: calc(var(--preloader-size)/4);

    &.mainPreloader_fixed,
    &.mainPreloader_absolute {
      margin: calc(var(--preloader-size)*(-0.75));
    }
  }
}
</style>